import React from "react";
import { Navigate, generatePath, useParams } from "react-router-dom";
import { paths } from "~/router/paths";

/**
 * Competitor Research was replaced by Competitor Analysis. Its product detail
 * page moved to `/product-library/:productId`, so old bookmarks and indexed
 * URLs are forwarded there instead of 404ing.
 */
export const LegacyCompetitorResearchDetailsRedirect: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  if (!productId) return <Navigate to={paths.app.competitorAnalysis} replace />;
  return (
    <Navigate
      to={generatePath(paths.app.productLibraryDetails, { productId })}
      replace
    />
  );
};
